import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Error from '../common/Message/error';
import Success from "../common/Message/success";
import DeleteModal from '../common/Modal/deleteModal';
import Sidebar from "../common/Sidebar";
import Spinner from "../common/Spinner/spinner";
import Table from "../common/Table";
import { deleteLocation, getLocationList } from "./action";
import './location.css';
import FilterModal from "./Modal/filterModal";
import Modal from './Modal/viewModal';
import { locationsSelector } from "./selector";
import { getFilterListError, setInitalState } from "./slice";
import BankInfoModal from "../common/Modal/BankInfoModal";
import {getLocationList as getSharedLocationList} from '../AddLocation/endpoints/action'
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const navigate = useNavigate();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const dispatch = useDispatch();
    const { locationList } = useSelector(locationsSelector);
    const { filteredList } = useSelector(locationsSelector);
    const { errorMessage, successMessage,loadingFlag } = useSelector(locationsSelector);
    const [formMessage, setFormMessage] = useState('');
    const [list, setLocationList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [showBankInfoModal,setShowBankInfoModal] = useState({status:false,location:null,getURL:null,postURL:null});
    const showSearch = true;
    const showView = true;
    const showBank = true;
    useEffect(() => {
        document.title = "Employers Section";
        dispatch(setInitalState());
    }, []);

    useEffect(() => {
        if (locationList.length > 0) {
            setLocationList(locationList);
            //setFormMessage('');
        }
    }, [locationList]);

    useEffect(() => {
        if (list.length > 0) {
            setFilterList(list);
        }
    }, [list]);

    useEffect(() => {
        if (filteredList.length > 0) {
            setFilterList(filteredList);
        }
    }, [filteredList]);

    useEffect(() => {
        if (successMessage !== null)
            setFormMessage('Location details deleted successfully!');
        if (config.baseUrl)
            dispatch(getLocationList(config.baseUrl, login.employerId, login.employerUniqueId));
    }, [successMessage]);

    useEffect(() => {
        if (errorMessage !== null)
            setFormMessage(errorMessage)
    }, [errorMessage]);

    const columns = React.useMemo(
        () => [
            {
                Header: 'Location Name',
                accessor: 'locationName',
                width: 170
            },
            {
                Header: 'Address',
                accessor: 'city',
                width: 170
            },
            {
                Header: 'Phone',
                accessor: 'phoneNumber',
            },
            {
                Header: 'Travel distance',
                accessor: 'acceptableTravelDistanceDisplayName',
                width: 200,
            },
        ],
        [],
    );


    useEffect(() => {
        if (config.baseUrl) {
            setFormMessage('');
            dispatch(getLocationList(config.baseUrl, login.employerId, login.employerUniqueId));
        }
    }, [config]);

    const showModal = (row) => {
        console.log(row)
        if (row && row.locationId) {
            const contacts = row.contacts;
            setContactList(prev => ([...prev, ...contacts]));
            navigate("/addlocations", {
                state: {
                    contacts: "true",
                    hideContact: false,
                    contactList: { 'locationId': row.locationId },
                    name: row.locationName,
                    locationDetails: row,
                }
            });
        }

    }

    const editLocation = (row) => {
        const detail = row;
        navigate("/addlocations", {
            state: {
                contacts: "false",
                name: row.locationName,
                locationDetails: row,
                contactList: row.contacts,
                isMapActive: true
            }
        });
        // window.location.reload(false);
    }


    const handleClose = () => setShow(false);

    const showDeleteModal = (row) => {
        setShowDelete(true);
        setDeleteId(row.locationId)
    }

    const handleDeleteClose = () => setShowDelete(false);

    const handleDelete = () => {
        dispatch(deleteLocation(config.baseUrl, deleteId, login.appUserId)).then(response => {
            dispatch(getSharedLocationList({baseUrl:config.baseUrl, empID:login.employerUniqueId}))
        })
        setShowDelete(false);
    }

    const showFilterModal = () => {
        setShowFilter(true);
    }

    const handleFilterClose = () => setShowFilter(false);

    const handleSubmit = (data) => {
        setShowFilter(false);
        dispatch(getFilterListError(" "));
    }

    const clearFilter = () => {
        setShowFilter(false);
        setFilterList(list);
    }

    const addNewLocation = () => {
        navigate("/addlocations",
            {
                state: {
                    contacts: "false",
                    hideContact: true
                }
            })
        window.location.reload(false);
    };
    const bankInfoModalHandler = async(row) => {
        if(row?.locationId){
            const location = {
                name:row?.locationName,
                id:row?.locationId
            }
            setShowBankInfoModal((prev) => ({
                ...prev,
                status: true,
                location,
                getURL: `BankAccount/get-bank-details-by-location-id?LocationId=${row?.locationId}`,
                postURL: `BankAccount/create-bank-account`,
              }));
        }
    };
    return (
        <div className="page main-margin">
            {/* <Loader /> */}
    {loadingFlag > 0 && <Spinner />}

            <Header />
            <Sidebar />
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <h1 className="page-title">Locations</h1>
                                {/* <div>
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                                        <li class="breadcrumb-item active" aria-current="page">Locations</li>
                                    </ol>
                                </div> */}
                            </div>
                            {
                                showBankInfoModal?.status ? <BankInfoModal showBankInfoModal={showBankInfoModal}  updateBankInfoModal={setShowBankInfoModal}/> : null
                            }
                            <div className="row">
                                <div class="col-xl-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <div id="myTable_wrapper" class="dataTables_wrapper no-footer">
                                                    <div class="newLocation">
                                                        <button class="btn btn-success" onClick={addNewLocation}>Add New Location</button>
                                                    </div>
                                                    {
                                                        errorMessage && <Error errorMessage={formMessage} />
                                                    }
                                                    {
                                                        successMessage && <Success successMessage={formMessage} />
                                                    }
                                                    <Table columns={columns} data={filterList} showSearch={showSearch} showView={showView} showModal={showModal} showDeleteModal={showDeleteModal} showFilterModal={showFilterModal} edit={editLocation} showBank={showBank} bankInfoModalHandler={bankInfoModalHandler} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Edit Modal Component */}
                            <Modal show={show} handleClose={handleClose} contactList={contactList} />

                            {/* Delete Modal Component */}
                            <DeleteModal showDelete={showDelete} handleDeleteClose={handleDeleteClose} handleDelete={handleDelete} />

                            {/* Filter Modal Component */}
                            <FilterModal showFilter={showFilter} handleFilterClose={handleFilterClose} handleSubmit={handleSubmit} clearFilter={clearFilter} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
